import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { featureFlags } from "../lib/config/featureFlags";
import { ROUTES } from "./constants";
import { protectedRoute } from "./helpers";

// Abacus Features
const AbacusHome = lazy(() => import("../abacus/home/Abacus-home"));
const AbacusCostHomePage = lazy(
	() => import("../abacus/components/home/Abacus-cost-home"),
);
const AbacusCostInputPage = lazy(
	() => import("../abacus/components/home/HomePage"),
);
const AbacusBenchmarkPage = lazy(
	() => import("../abacus/components/benchmark/BenchmarkContent"),
);
const AbacusSearchPage = lazy(
	() => import("../abacus/components/searchDatabase/SearchPage"),
);
const AbacusDurationHome = lazy(
	() => import("../abacus/duration/Abacus-duration-home"),
);
const AbacusProductivityPage = lazy(
	() => import("../abacus/duration/productivity/index"),
);
const AbacusProductivityDocumentView = lazy(
	() => import("../abacus/duration/productivity/DocumentView"),
);

// Abacus Duration - import concrete modules to avoid pulling barrel extras
const AbacusDurationBenchmarkPage = lazy(
	() => import("../abacus/duration/benchmarking/index"),
);
const AbacusDurationSearchPage = lazy(
	() => import("../abacus/duration/search/SearchPage"),
);
const AbacusDurationInformationPage = lazy(
	() => import("../abacus/duration/info/DurationInformationPage"),
);

export const abacusRoutes: RouteObject[] = featureFlags.isAbacusEnabled
	? [
			{
				path: ROUTES.ABACUS,
				element: protectedRoute(<AbacusHome />),
			},
			{
				path: ROUTES.ABACUS_COST,
				element: protectedRoute(<AbacusCostHomePage />),
			},
			{
				path: ROUTES.ABACUS_COST_INPUT,
				element: protectedRoute(<AbacusCostInputPage />),
			},
			{
				path: ROUTES.ABACUS_COST_BENCHMARK,
				element: protectedRoute(<AbacusBenchmarkPage />),
			},
			{
				path: ROUTES.ABACUS_COST_SEARCH,
				element: protectedRoute(<AbacusSearchPage />),
			},
			{
				path: ROUTES.ABACUS_DURATION,
				element: protectedRoute(<AbacusDurationHome />),
			},
			{
				path: ROUTES.ABACUS_DURATION_INPUT,
				element: protectedRoute(<AbacusDurationInformationPage />),
			},
			{
				path: ROUTES.ABACUS_DURATION_BENCHMARK,
				element: protectedRoute(<AbacusDurationBenchmarkPage />),
			},
			{
				path: ROUTES.ABACUS_DURATION_SEARCH,
				element: protectedRoute(<AbacusDurationSearchPage />),
			},
			{
				path: ROUTES.ABACUS_DURATION_PRODUCTIVITY,
				element: protectedRoute(<AbacusProductivityPage />),
			},
			{
				path: ROUTES.ABACUS_DURATION_PRODUCTIVITY_DOC,
				element: protectedRoute(<AbacusProductivityDocumentView />),
			},
		]
	: [];
